<template>
  <div class="order">
    <v-expansion-panels accordion multiple v-model="panel">
      <v-expansion-panel class="expansion-panel" :key="1">
        <v-expansion-panel-header>
          <span>{{ $t("steps.customer.label") }}</span>
          <v-alert
            class="alert"
            v-if="!customerDataOkCanSave"
            dense
            outlined
            type="error"
          >
            {{ $t("steps.customer.alert.fill_data") }}
          </v-alert>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <Customer :isManualOrder="true"></Customer>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel class="expansion-panel" :key="0">
        <v-expansion-panel-header><span>{{
          $t("orders.add_materials")
        }}</span>
        <v-alert
            class="alert"
            dense
            text
            type="info"
          >
            {{ $t("steps.materials.alert.info") }}
          </v-alert>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <MaterialSelect :edit="edit">

            </MaterialSelect>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
        <OfferCalculation>

        </OfferCalculation>

    <div style="padding: 20px 0 10px">
      <v-btn @click="saveOffer" color="primary">{{ $t("base.save") }} </v-btn>
      <v-btn @click="cancelAndBack" text>{{ $t("base.cancel") }}</v-btn>
    </div>
  </div>
</template>

<script>
import Customer from "@/components/steps/Customer";
import Partner from "@/components/orders/Partner";
import MaterialSelect from "@/components/orders/MaterialSelect";
import OfferCalculation from "@/components/orders/OfferCalculation";

export default {
  name: "ManualOrder",
  components: {Customer, Partner, MaterialSelect, OfferCalculation },
  props: {
    edit: {type: Boolean, default: false}
  },
  computed: {
    customerDataOkCanSave() {
      return (
        this.$store.state.configurator.customer.hasOwnProperty("email") &&
        this.$store.state.configurator.customer.email !== ""
      );
    },
    currentLocale(){
        return this.$cookies.get("locale");
    }
  },
  data() {
    return {
      panel: [1],
      dialog: false,
      valid: true,
    };
  },
  methods: {
    saveOffer() {
      let payload = this.$store.getters.manualOrderPayload;

      let request =
        payload.id > 0
          ? this.$http.put("orders/manual-order/" + payload.id, payload)
          : this.$http.post("orders/manual-order/", payload);
      request
        .then((response) => {
          alert("Oferta zapisana");
        //   this.$store.commit("cleanConfigurator");

        })
        .catch(() => {
          alert("Błąd przy zapisywaniu oferty");
        });
    },
    cancelAndBack() {
      this.$store.commit("cleanConfigurator");
      this.$router.push({ name: "Orders" });
    },
  },
  mounted() {
    if (!this.edit) {
                    this.$store.commit("cleanConfigurator");
                    }
  },
};
</script>

<style scoped>
.product-summary-row {
  color: #464646;
  padding: 10px 16px;
  line-height: 20px;
  font-size: 18px;
  font-weight: lighter;
  display: block;
  width: 100%;
}

.product-summary-row .value {
  font-weight: initial;
}
.title {
  text-align: left;
}
.complementary {
  height: 30px;
  line-height: 30px;
}
.order {
  padding: 5%;
}
.alert {
  margin-bottom: 0px;
  margin-right: 30px;
}
.expansion-panel {
  margin-bottom: 10px;
}
</style>
